export default __webpack_public_path__ + "static/media/member.83b9b3f3.svg";